import React, { useState, useEffect } from 'react';
import './FruitsCalculator.css';

// Corrected base prices from official Grow a Garden wiki
const fruits = [
  // Basic Seed Pack
  { name: 'Carrot', price: 18 },
  { name: 'Strawberry', price: 14 },
  { name: 'Blueberry', price: 23 }, // Corrected from 21 to 23
  
  // Flower Seed Pack  
  { name: 'Orange Tulip', price: 767 }, // Corrected from 792 to 767
  { name: 'Daffodil', price: 903 }, // Corrected from 988 to 903
  { name: 'Rose', price: 4513 }, // Corrected from 488 to 4513
  
  // Veggie Seed Pack
  { name: 'Tomato', price: 27 }, // Corrected from 35 to 27
  { name: 'Corn', price: 36 }, // Corrected from 44 to 36
  { name: 'Cauliflower', price: 1300 },
  
  // Fruit Seed Pack
  { name: 'Raspberry', price: 90 }, // Corrected from 98 to 90
  { name: 'Pear', price: 500 }, // Corrected from 553 to 500
  { name: 'Watermelon', price: 2708 }, // Corrected from 2905 to 2708
  { name: 'Pumpkin', price: 3069 }, // Corrected from 3854 to 3069
  { name: 'Apple', price: 248 }, // Corrected from 266 to 248
  
  // Tree Seed Pack
  { name: 'Bamboo', price: 3610 }, // Corrected from 3944 to 3610
  { name: 'Coconut', price: 361 }, // Corrected from 2670 to 361
  { name: 'Cactus', price: 3068 }, // Corrected from 3224 to 3068
  
  // Exotic Seed Pack
  { name: 'Dragon Fruit', price: 4287 }, // Corrected from 4566 to 4287
  { name: 'Mango', price: 7500 }, // Corrected from 6308 to 7500
  { name: 'Grape', price: 7085 }, // Corrected from 7554 to 7085
  { name: 'Kiwi', price: 2482 },
  { name: 'Bell Pepper', price: 7229 }, // Corrected from 4964 to 7229
  { name: 'Prickly Pear', price: 6318 },
  { name: 'Loquat', price: 7220 },
  { name: 'Feijoa', price: 11733 },
  
  // Premium Seeds (Robux)
  { name: 'Rosy Delight', price: 115000 },
  { name: 'Parasol Flower', price: 200000 },
  { name: 'Cantaloupe', price: 50000 },
  { name: 'Crocus', price: 27075 },
  { name: 'Succulent', price: 19500 },
  
  // Bizzy Bear Seeds
  { name: 'Bee Balm', price: 16245 },
  { name: 'Nectar Thorn', price: 40111 },
  { name: 'Nectarine', price: 36100 },
  { name: 'Sugar Apple', price: 43320 },
  { name: 'Dragon Pepper', price: 80221 },
  { name: 'Cocovine', price: 60166 },
  { name: 'Bendboo', price: 139888 },
  { name: 'Suncoil', price: 72200 },
  { name: 'Violet Corn', price: 45000 },
  
  // Night Seeds
  { name: 'Moonglow', price: 18000 }, // Corrected from 20300 to 18000
  { name: 'Moon Melon', price: 16245 }, // Corrected from 17750 to 16245
  { name: 'Moonflower', price: 8500 }, // Corrected from 8900 to 8500
  { name: 'Celestiberry', price: 9025 }, // Corrected from 9100 to 9025
  { name: 'Moon Mango', price: 45125 }, // Corrected from 24340 to 45125
  { name: 'Moon Blossom', price: 45125 }, // Corrected from 53512 to 45125
  
  // Blood Moon Event
  { name: 'Blood Banana', price: 5415 }, // Corrected from 6100 to 5415
  
  // Regular Seeds (Daily Quests)
  { name: 'Glowshroom', price: 271 }, // Corrected from 282 to 271
  { name: 'Nightshade', price: 3159 }, // Corrected from 2300 to 3159
  { name: 'Mint', price: 5415 }, // Corrected from 6800 to 5415
  { name: 'Peach', price: 271 }, // Corrected from 283 to 271
  { name: 'Pineapple', price: 1805 }, // Corrected from 2350 to 1805
  { name: 'Soul Fruit', price: 3000 }, // Corrected from 3328 to 3000
  { name: 'Cursed Fruit', price: 15000 }, // Corrected from 15944 to 15000
  { name: 'Lotus', price: 24598 },
  { name: 'Candy Blossom', price: 90250 }, // Corrected from 99436 to 90250
  { name: 'Cherry Blossom', price: 566 },
  { name: 'Venus Fly Trap', price: 18854 },
  { name: 'Banana', price: 1579 }, // Corrected from 1634 to 1579
  { name: 'Lemon', price: 500 }, // Corrected from 554 to 500
  { name: 'Passionfruit', price: 3204 }, // Corrected from 3299 to 3204
  { name: 'Eggplant', price: 7089 },
  { name: 'Cranberry', price: 2054 },
  { name: 'Durian', price: 4911 },
  
  // Event Seeds
  { name: 'Easter Egg', price: 2256 }, // Corrected from 4844 to 2256
  { name: 'Starfruit', price: 13528 }, // Corrected from 14559 to 13528
  { name: 'Papaya', price: 1000 }, // Corrected from 1288 to 1000
  { name: 'Candy Sunflower', price: 145000 }, // Corrected from 164440 to 145000
  { name: 'Red Lollipop', price: 70000 }, // Corrected from 81297 to 70000
  { name: 'Chocolate Carrot', price: 16500 }, // Corrected from 17258 to 16500
  
  // Bizzy Bee Event
  { name: 'Purple Dahlia', price: 67469 },
  { name: 'Lilac', price: 31588 },
  { name: 'Foxglove', price: 14000 },
  { name: 'Manuka Flower', price: 22563 },
  { name: 'Lavender', price: 22563 },
  { name: 'Dandelion', price: 65000 },
  { name: 'Nectarshade', price: 43125 },
  { name: 'Honeysuckle', price: 90250 }, // Corrected from 90000 to 90250
  { name: 'Pink Lily', price: 58663 },
  { name: 'Hive Fruit', price: 45125 }, // Corrected from 54125 to 45125
  { name: 'Sunflower', price: 135375 }, // Corrected from 135000 to 135375
  
  // Additional crops from wiki
  { name: 'Mushroom', price: 136278 },
  { name: 'Cacao', price: 10830 },
  { name: 'Beanstalk', price: 18000 },
  { name: 'Ember Lily', price: 72000 },
  { name: 'Lumira', price: 76000 },
];

// Updated mutations with CORRECT multipliers from official wiki
const mutations = [
  // Growth Mutations
  { name: 'Ripe', multiplier: 1, source: 'Rare natural replacement (Sugar Apple only)' },
  { name: 'Gold', multiplier: 25, source: '1% chance / Dragonfly pet' },
  { name: 'Rainbow', multiplier: 50, source: '0.1% chance / Butterfly pet' },

  // Environmental Mutations
  { name: 'Wet', multiplier: 2, source: 'Rain, Thunderstorm, Sea Turtle' },
  { name: 'Windstruck', multiplier: 2, source: 'Windy, Gale' },
  { name: 'Moonlit', multiplier: 2, source: 'Nighttime' },
  { name: 'Chilled', multiplier: 2, source: 'Frost, Polar Bear' },
  { name: 'Bloodlit', multiplier: 4, source: 'Blood Moon' },
  { name: 'Twisted', multiplier: 5, source: 'Tornado' },
  { name: 'Frozen', multiplier: 10, source: 'Wet + Chilled / Flower Froster' },
  { name: 'Shocked', multiplier: 100, source: 'Thunderstorm / Jandel Storm / Spray' },
  { name: 'Celestial', multiplier: 120, source: 'Meteor Shower' },

  // Limited Mutations
  { name: 'Choc', multiplier: 2, source: 'Chocolate Sprinkler / Rain' },
  { name: 'Pollinated', multiplier: 3, source: 'Bee Swarm / Bee pets / Spray' },
  { name: 'Burnt', multiplier: 4, source: 'Cooked Owl pet' },
  { name: 'Verdant', multiplier: 4, source: 'Scarlet Macaw pet' },
  { name: 'HoneyGlazed', multiplier: 5, source: 'Honey Sprinkler / Bear Bee' },
  { name: 'Plasma', multiplier: 5, source: 'Laser Storm (admin)' },
  { name: 'Heavenly', multiplier: 5, source: 'Floating Jandel (admin)' },
  { name: 'Paradisal', multiplier: 18, source: 'Verdant + Sundried' },
  { name: 'Cooked', multiplier: 25, source: 'Cooked Owl pet' },
  { name: 'Zombified', multiplier: 25, source: 'Chicken Zombie pet' },
  { name: 'Molten', multiplier: 25, source: 'Volcano event' },
  { name: 'Sundried', multiplier: 85, source: 'Heatwave / Tanning Mirror' },
  { name: 'Alienlike', multiplier: 100, source: 'Alien Invasion' },
  { name: 'Galactic', multiplier: 120, source: 'Space Travel' },
  { name: 'Disco', multiplier: 125, source: 'Disco event / Disco Bee' },
  { name: 'Voidtouched', multiplier: 135, source: 'Black Hole (admin)' },
  { name: 'Dawnbound', multiplier: 150, source: 'Sun God + 4 Sunflowers' }
];

// Updated mutex groups with new combinations
const MUTEX_GROUPS = [
  ['Gold', 'Rainbow'],
  ['Wet', 'Chilled', 'Frozen'],
  ['Burnt', 'Cooked'],
  ['Paradisal', 'Sundried', 'Verdant'],
  ['Cursed', 'Blessed'],
  ['Toxic', 'Radioactive'],
  ['Shadowed', 'Luminous'],
  ['Spectral', 'Phantom'],
  ['Dimensional', 'Temporal', 'Quantum'],
  ['Divine', 'Mythical', 'Cosmic']
];

const FruitsCalculator = () => {
  const [kg, setKg] = useState('');
  const [fruit, setFruit] = useState(fruits[0].name);
  const [selectedMutations, setSelectedMutations] = useState([]);
  const [total, setTotal] = useState(null);
  const [fruitSearch, setFruitSearch] = useState('');

  // Filter fruits by search
  const filteredFruits = fruits.filter(f =>
    f.name.toLowerCase().includes(fruitSearch.toLowerCase())
  );

  // Sync selected fruit with filtered list
  useEffect(() => {
    if (
      filteredFruits.length > 0 &&
      !filteredFruits.some(f => f.name === fruit)
    ) {
      setFruit(filteredFruits[0].name);
    }
    // If search is empty, reset to first fruit in full list
    if (fruitSearch === '' && fruit !== fruits[0].name) {
      setFruit(fruits[0].name);
    }
  }, [fruitSearch, filteredFruits, fruit]);

  const handleMutationChange = (e) => {
    const { value, checked } = e.target;
    setSelectedMutations(prev =>
      checked
        ? [...prev, value]
        : prev.filter(m => m !== value)
    );
  };

  const handleCalculate = (e) => {
    e.preventDefault();
    const fruitObj = fruits.find(f => f.name === fruit);
    const mass = parseFloat(kg || 0);

    if (mass <= 0) {
      setTotal(null);
      return;
    }

    // Remove extra mutations from mutex groups (only keep the first found in each group)
    let filteredMutations = [...selectedMutations];
    for (const group of MUTEX_GROUPS) {
      const found = filteredMutations.find(m => group.includes(m));
      if (found) {
        filteredMutations = filteredMutations.filter(m => !group.includes(m) || m === found);
      }
    }

    // Growth Mutation: Ripe (x1), Gold (x20), Rainbow (x50), or None (x1)
    let growthMultiplier = 1;
    if (filteredMutations.includes('Rainbow')) {
      growthMultiplier = 50;
    } else if (filteredMutations.includes('Gold')) {
      growthMultiplier = 20;
    } else if (filteredMutations.includes('Ripe')) {
      growthMultiplier = 1;
    }

    // Remove growth mutations from environmental list
    const environmentalMutations = filteredMutations.filter(
      m => !['Gold', 'Rainbow', 'Ripe'].includes(m)
    );

    // Paradisal logic: If Paradisal is present, allow either Verdant or Sundried (but not both)
    if (environmentalMutations.includes('Paradisal')) {
      const hasVerdant = environmentalMutations.includes('Verdant');
      const hasSundried = environmentalMutations.includes('Sundried');
      if (hasVerdant && hasSundried) {
        // Remove Sundried (arbitrary, or you can remove Verdant)
        const idx = environmentalMutations.indexOf('Sundried');
        if (idx !== -1) environmentalMutations.splice(idx, 1);
      }
    }

    // Σ Mutations = Sum of all environmental mutation multipliers
    const sumOfMutations = environmentalMutations.reduce((sum, mutationName) => {
      const mutation = mutations.find(m => m.name === mutationName);
      return sum + (mutation ? mutation.multiplier : 0);
    }, 0);

    // Number of Mutations = Count of environmental mutations
    const numberOfMutations = environmentalMutations.length;

    // Environmental Factor = (1 + Σ Mutations - Number of Mutations)
    const environmentalFactor = Math.max(0, 1 + sumOfMutations - numberOfMutations);

    // EXACT WIKI FORMULA
    const fruitConstant = fruitObj.price;
    const massSquared = mass * mass;
    const totalPrice = fruitConstant * massSquared * growthMultiplier * environmentalFactor;

    const finalPrice = Math.max(0, Math.round(totalPrice));
    setTotal(isNaN(finalPrice) ? null : finalPrice);
  };

  const isDisabled = (mutationName) => {
    // For each group, if this mutation is not selected but another in the group is, disable it
    for (const group of MUTEX_GROUPS) {
      if (group.includes(mutationName)) {
        // If any other in the group is selected, and this one is not, disable
        if (
          selectedMutations.some(m => group.includes(m)) &&
          !selectedMutations.includes(mutationName)
        ) {
          return true;
        }
      }
    }
    return false;
  };

  return (
    <div className="fruits-calculator">
      <div
        style={{
          background: '#ff2222',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1.5em',
          padding: '0.75em',
          textAlign: 'center',
          borderRadius: '8px',
          marginBottom: '1em',
          border: '2px solid #b30000',
          letterSpacing: '1px',
          boxShadow: '0 2px 8px rgba(255,0,0,0.15)'
        }}
      >
        🚧 Still Under Development 🚧
      </div>
      <h2>Roblox Grow a Garden Fruit Calculator</h2>
      <div style={{ fontSize: '0.95em', color: '#888', marginBottom: '0.5em' }}>
        Updated: June 25, 2025
      </div>
      <form onSubmit={handleCalculate} className="fruit-calc-form">
        <label>
          Search Crop:
          <input
            type="text"
            placeholder="Type to search..."
            value={fruitSearch}
            onChange={e => setFruitSearch(e.target.value)}
            style={{ marginBottom: '0.5em' }}
          />
        </label>
        <label>
          Fruit:
          <select
            value={fruit}
            onChange={e => setFruit(e.target.value)}
          >
            {filteredFruits.length === 0 && (
              <option disabled>No crops found</option>
            )}
            {filteredFruits.map(f => (
              <option key={f.name} value={f.name}>
                {f.name} ({f.price.toLocaleString()}¢)
              </option>
            ))}
          </select>
        </label>
        <label>
          Kilograms (kg):
          <input
            type="number"
            min="0"
            step="0.01"
            value={kg}
            onChange={e => setKg(e.target.value)}
            placeholder="Enter kg"
            required
          />
        </label>
        <fieldset className="mutation-fieldset">
          <legend>Mutations (select any):</legend>
          <div className="mutation-grid">
            {mutations.map(m => (
              <label key={m.name} className="mutation-checkbox" title={m.source}>
                <input
                  type="checkbox"
                  value={m.name}
                  checked={selectedMutations.includes(m.name)}
                  onChange={handleMutationChange}
                  disabled={isDisabled(m.name)}
                />
                <span className="mutation-label">{m.name} (x{m.multiplier})</span>
              </label>
            ))}
          </div>
        </fieldset>
        <button type="submit">Calculate Price</button>
        <button
          type="button"
          onClick={() => {
            setKg('');
            setFruit(fruits[0].name);
            setSelectedMutations([]);
            setTotal(null);
            setFruitSearch('');
          }}
          style={{ marginLeft: '0.5em' }}
        >
          Reset
        </button>
         <button
          type="button"
          onClick={() => {
            setSelectedMutations(
            ['Rainbow', 'Frozen', ...mutations
                .map(m => m.name)
                .filter(name => !['Gold', 'Rainbow', 'Wet', 'Chilled', 'Frozen'].includes(name))
            ]
            );
          }}
          style={{ marginLeft: '0.5em' }}
        >
          Max
        </button>
      </form>
      {total !== null && (
        <div className="fruit-calc-result">
          <strong>Total Price:</strong> {total.toLocaleString()} ¢
        </div>
      )}
      <p className="fruit-calc-note">
        Use this calculator to estimate your fruit price in Roblox Grow a Garden, including all trending mutations!
      </p>
      <details className="mutation-table-details">
        <summary>View All Mutations & Multipliers</summary>
        <table className="mutation-table">
          <thead>
            <tr>
              <th>Mutation</th>
              <th>Multiplier</th>
              <th>Source/Event/Pet</th>
            </tr>
          </thead>
          <tbody>
            {mutations.map(m => (
              <tr key={m.name}>
                <td>{m.name}</td>
                <td>x{m.multiplier}</td>
                <td>{m.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </details>
    </div>
  );
};

export default FruitsCalculator;